// Module
var code = "<template> <require from=\"app/core/components/custom-fields/custom-field-choices-grid\"></require> <custom-field-choices-grid custom-field-definition-id.bind=\"userDefinedFieldDefinitionId\" custom-field-definition.bind=\"userDefinedFieldDefinition\"></custom-field-choices-grid> </template> ";
// Exports
module.exports = code;